import { Box, ITheme, Typography, lighten, useTheme } from '@mui/material';
import React from 'react';
import { Utilities } from '../../../utility/utils';
import { useNavigate } from 'react-router-dom';
import { AUTHENTICATED_ROUTES } from '../../../resources/routes-constants';



export interface IActivePortfolioBubbleProps {
    type: 'primary' | 'secondary' | 'tertiary';
    id?: number;
    name?: string;
    completion?: number;
    loading?: boolean;
}

const ActivePortfolioBubble: React.FC<IActivePortfolioBubbleProps> = ({ id, type, name, completion, loading }) => {
    const theme = useTheme() as ITheme;
    const navigate = useNavigate();
    
    const properties = {
        primary: {
            graphRadius:75.5,
            radius: 66.25,
            color: theme.palette.leo.color3,
            stroke: 8
        },
        secondary: {
            graphRadius:66.8,
            radius: 58,
            color: theme.palette.leo.color11,
            stroke: 8
        },
        tertiary: {
            graphRadius:60,
            radius: 52.5,
            color: theme.palette.leo.color13,
            stroke: 4
        }
    }

    if (name === undefined || loading){
        return <circle cx="0" cy="0" r={properties[type].graphRadius} fill={theme.palette.common.white} className="loading-radius" />
    }

    const onBubbleClick = () => {
        navigate(AUTHENTICATED_ROUTES.PORTFOLIO_DETAILS_ROUTE.replace(":id", `${id}`));
    }
    return <>
        <circle cx="0" cy="0" r={properties[type].graphRadius} fill={lighten(properties[type].color, 0.75)} />
        <circle cx="0" cy="0" r={properties[type].radius} fill={theme.palette.common.white} />
        <foreignObject x={-properties[type].radius} y={-properties[type].radius} width={properties[type].radius*2} height={properties[type].radius*2} style={{ cursor: "pointer", borderRadius: "50%"}}  onClick={onBubbleClick}>
            <Box width={"80%"} height={"100%"} display={"flex"} flexDirection={"column"} alignItems={"center"} justifyContent={"center"} gap={"8px"} margin="0 auto">
                <Typography component={"h3"} fontSize={"16px"} lineHeight={"19.5px"} fontWeight={"600"} textAlign={"center"}>{name}</Typography>
                {completion && <Typography fontSize={"16px"} lineHeight={"19.5px"} fontWeight={"600"} textAlign={"center"}>{`${(completion * 100).toFixed(0)} %`}</Typography>}
            </Box>
        </foreignObject>
        {completion && <path d={Utilities.f_svg_ellipse_arc([0, 0], [properties[type].graphRadius-4, properties[type].graphRadius-4], [0, 2 * Math.PI * completion], -Math.PI/2)} stroke={properties[type].color} strokeLinecap='round' strokeWidth="8" strokeDasharray={"500"} strokeDashoffset={"500"} className='drawable-illustration'/>}
    </>;
}

export default ActivePortfolioBubble;